/**
 * Trusted Types: the production CSP has `require-trusted-types-for 'script'`, which
 * makes `new Worker(url)` and `serviceWorker.register(url)` sinks. This policy only
 * blesses same-origin script URLs.
 */
interface ScriptUrlPolicy {
  createScriptURL(input: string): unknown;
}
let policy: ScriptUrlPolicy | null = null;

export function trustedScriptUrl(url: string): string {
  const tt = (globalThis as { trustedTypes?: { createPolicy(name: string, rules: { createScriptURL(s: string): string }): ScriptUrlPolicy } }).trustedTypes;
  if (!tt) return url;
  policy ??= tt.createPolicy("homing-script-url", {
    createScriptURL(s) {
      const u = new URL(s, location.href);
      if (u.origin !== location.origin) throw new TypeError(`refusing cross-origin script URL ${u.origin}`);
      return u.href;
    },
  });
  // A TrustedScriptURL is accepted wherever the DOM types say string.
  return policy.createScriptURL(url) as string;
}

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register(trustedScriptUrl("/sw.js"), { scope: "/" }).catch((e: unknown) => console.warn("service worker:", e));
}
